// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/common/common_types.proto (package api.v1.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/common/common_types.proto.
 */
export const file_v1_common_common_types: GenFile = /*@__PURE__*/
  fileDesc("Chx2MS9jb21tb24vY29tbW9uX3R5cGVzLnByb3RvEg1hcGkudjEuY29tbW9uIoACCg1Qcm9maWxlRmllbGRzEg0KBWVtYWlsGAEgASgJEhcKD2NvdmVyX2ltYWdlX3VybBgCIAEoCRISCgphdmF0YXJfdXJsGAMgASgJEhQKDGRpc3BsYXlfbmFtZRgEIAEoCRILCgNiaW8YBSABKAkSFwoPZm9sbG93ZXJzX2NvdW50GAYgASgFEhcKD2ZvbGxvd2luZ19jb3VudBgHIAEoBRIuCgpjcmVhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCLYAQoITG9jYXRpb24SEAoIcGxhY2VfaWQYASABKAkSEQoJYWRkcmVzc18xGAIgASgJEhEKCWFkZHJlc3NfMhgDIAEoCRIMCgRjaXR5GAQgASgJEg0KBXN0YXRlGAUgASgJEhMKC3Bvc3RhbF9jb2RlGAYgASgJEg8KB2NvdW50cnkYByABKAkSEAoIbGF0aXR1ZGUYCCABKAISEQoJbG9uZ2l0dWRlGAkgASgCEhgKEHBsdXNfY29kZV9nbG9iYWwYCiABKAkSEgoKaXNfcHJpbWFyeRgLIAEoCCJoChRWZXJpZmljYXRpb25Eb2N1bWVudBIVCg1kb2N1bWVudF90eXBlGAEgASgJEhAKCGZpbGVfdXJsGAIgASgJEhEKCWZpbGVfbmFtZRgDIAEoCRIUCgxjb250ZW50X3R5cGUYBCABKAkiQQoUVGVhbU1lbWJlckludml0YXRpb24SDQoFZW1haWwYASABKAkSDAoEcm9sZRgCIAEoCRIMCgRuYW1lGAMgASgJIkAKBVZlbnVlEgwKBG5hbWUYASABKAkSKQoIbG9jYXRpb24YAiABKAsyFy5hcGkudjEuY29tbW9uLkxvY2F0aW9uIvoBCgdQcm9maWxlEg0KBWVtYWlsGAEgASgJEhcKD2NvdmVyX2ltYWdlX3VybBgCIAEoCRISCgphdmF0YXJfdXJsGAMgASgJEhQKDGRpc3BsYXlfbmFtZRgEIAEoCRILCgNiaW8YBSABKAkSFwoPZm9sbG93ZXJzX2NvdW50GAYgASgFEhcKD2ZvbGxvd2luZ19jb3VudBgHIAEoBRIuCgpjcmVhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCLFAgoFSW1hZ2USCgoCaWQYASABKAkSCwoDdXJsGAIgASgJEg0KBXVzYWdlGAMgASgJEhUKCGFsdF90ZXh0GAQgASgJSACIAQESFQoIcG9zaXRpb24YBSABKAVIAYgBARIZCgxzdG9yYWdlX3BhdGgYBiABKAlIAogBARISCgV3aWR0aBgHIAEoBUgDiAEBEhMKBmhlaWdodBgIIAEoBUgEiAEBEhYKCW1pbWVfdHlwZRgJIAEoCUgFiAEBEhcKCnNpemVfYnl0ZXMYCiABKANIBogBARIUCgxjb250ZW50X2hhc2gYCyABKAlCCwoJX2FsdF90ZXh0QgsKCV9wb3NpdGlvbkIPCg1fc3RvcmFnZV9wYXRoQggKBl93aWR0aEIJCgdfaGVpZ2h0QgwKCl9taW1lX3R5cGVCDQoLX3NpemVfYnl0ZXMqiAEKDUxpc3RpbmdTdGF0dXMSHgoaTElTVElOR19TVEFUVVNfVU5TUEVDSUZJRUQQABIZChVMSVNUSU5HX1NUQVRVU19BQ1RJVkUQARIbChdMSVNUSU5HX1NUQVRVU19JTkFDVElWRRACEh8KG0xJU1RJTkdfU1RBVFVTX09VVF9PRl9TVE9DSxADQsEBChFjb20uYXBpLnYxLmNvbW1vbkIQQ29tbW9uVHlwZXNQcm90b1ABWkRnaXRodWIuY29tL2R3YXluZWxhdm9uL2xvY2FsLWNvbW11bml0eS1wbGF0Zm9ybS9hcGkvZ2VuL2dvL3YxL2NvbW1vbqICA0FWQ6oCDUFwaS5WMS5Db21tb27KAg1BcGlcVjFcQ29tbW9u4gIZQXBpXFYxXENvbW1vblxHUEJNZXRhZGF0YeoCD0FwaTo6VjE6OkNvbW1vbmIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Common profile fields that can be reused across different profile types
 *
 * @generated from message api.v1.common.ProfileFields
 */
export type ProfileFields = Message<"api.v1.common.ProfileFields"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string cover_image_url = 2;
   */
  coverImageUrl: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: string bio = 5;
   */
  bio: string;

  /**
   * @generated from field: int32 followers_count = 6;
   */
  followersCount: number;

  /**
   * @generated from field: int32 following_count = 7;
   */
  followingCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.common.ProfileFields.
 * Use `create(ProfileFieldsSchema)` to create a new message.
 */
export const ProfileFieldsSchema: GenMessage<ProfileFields> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 0);

/**
 * Location represents a physical location
 *
 * @generated from message api.v1.common.Location
 */
export type Location = Message<"api.v1.common.Location"> & {
  /**
   * @generated from field: string place_id = 1;
   */
  placeId: string;

  /**
   * @generated from field: string address_1 = 2;
   */
  address1: string;

  /**
   * @generated from field: string address_2 = 3;
   */
  address2: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 6;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 7;
   */
  country: string;

  /**
   * @generated from field: float latitude = 8;
   */
  latitude: number;

  /**
   * @generated from field: float longitude = 9;
   */
  longitude: number;

  /**
   * @generated from field: string plus_code_global = 10;
   */
  plusCodeGlobal: string;

  /**
   * @generated from field: bool is_primary = 11;
   */
  isPrimary: boolean;
};

/**
 * Describes the message api.v1.common.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 1);

/**
 * Business Types
 *
 * @generated from message api.v1.common.VerificationDocument
 */
export type VerificationDocument = Message<"api.v1.common.VerificationDocument"> & {
  /**
   * e.g., "business_license", "id_proof"
   *
   * @generated from field: string document_type = 1;
   */
  documentType: string;

  /**
   * @generated from field: string file_url = 2;
   */
  fileUrl: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 4;
   */
  contentType: string;
};

/**
 * Describes the message api.v1.common.VerificationDocument.
 * Use `create(VerificationDocumentSchema)` to create a new message.
 */
export const VerificationDocumentSchema: GenMessage<VerificationDocument> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 2);

/**
 * @generated from message api.v1.common.TeamMemberInvitation
 */
export type TeamMemberInvitation = Message<"api.v1.common.TeamMemberInvitation"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * e.g., "org:admin", "org:member"
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * Optional name for the invitation
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message api.v1.common.TeamMemberInvitation.
 * Use `create(TeamMemberInvitationSchema)` to create a new message.
 */
export const TeamMemberInvitationSchema: GenMessage<TeamMemberInvitation> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 3);

/**
 * @generated from message api.v1.common.Venue
 */
export type Venue = Message<"api.v1.common.Venue"> & {
  /**
   * Name of the venue
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Physical location details of venue
   *
   * @generated from field: api.v1.common.Location location = 2;
   */
  location?: Location;
};

/**
 * Describes the message api.v1.common.Venue.
 * Use `create(VenueSchema)` to create a new message.
 */
export const VenueSchema: GenMessage<Venue> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 4);

/**
 * Profile Types
 *
 * @generated from message api.v1.common.Profile
 */
export type Profile = Message<"api.v1.common.Profile"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * URL of the profile's cover/banner image
   *
   * @generated from field: string cover_image_url = 2;
   */
  coverImageUrl: string;

  /**
   * URL of the profile's avatar/profile picture
   *
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * User's display name shown publicly
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * User's profile bio/description
   *
   * @generated from field: string bio = 5;
   */
  bio: string;

  /**
   * Count of users following this profile
   *
   * @generated from field: int32 followers_count = 6;
   */
  followersCount: number;

  /**
   * Count of users this profile follows
   *
   * @generated from field: int32 following_count = 7;
   */
  followingCount: number;

  /**
   * Date and time the profile was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * Date and time the profile was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.common.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 5);

/**
 * Image represents an image entity
 *
 * @generated from message api.v1.common.Image
 */
export type Image = Message<"api.v1.common.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;

  /**
   * @generated from field: optional int32 position = 5;
   */
  position?: number;

  /**
   * @generated from field: optional string storage_path = 6;
   */
  storagePath?: string;

  /**
   * @generated from field: optional int32 width = 7;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 8;
   */
  height?: number;

  /**
   * @generated from field: optional string mime_type = 9;
   */
  mimeType?: string;

  /**
   * @generated from field: optional int64 size_bytes = 10;
   */
  sizeBytes?: bigint;

  /**
   * @generated from field: string content_hash = 11;
   */
  contentHash: string;
};

/**
 * Describes the message api.v1.common.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_v1_common_common_types, 6);

/**
 * Listing Status
 *
 * @generated from enum api.v1.common.ListingStatus
 */
export enum ListingStatus {
  /**
   * @generated from enum value: LISTING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LISTING_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: LISTING_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,

  /**
   * @generated from enum value: LISTING_STATUS_OUT_OF_STOCK = 3;
   */
  OUT_OF_STOCK = 3,
}

/**
 * Describes the enum api.v1.common.ListingStatus.
 */
export const ListingStatusSchema: GenEnum<ListingStatus> = /*@__PURE__*/
  enumDesc(file_v1_common_common_types, 0);

